<style>
  /* Treat all as divs */
  .header-fixed>thead,
  .header-fixed>tbody,
  .header-fixed>thead>tr,
  .header-fixed>tbody>tr,
  .header-fixed>thead>tr>th,
  .header-fixed>tbody>tr>td {
    display: block;
  }

  /* Prevent header to wrap */
  .header-fixed>thead>tr>th {
    white-space: nowrap;
    background-color: lightgrey;
  }

  .header-fixed>tbody>tr:after,
  .header-fixed>thead>tr:after {
    content: ' ';
    display: block;
    visibility: hidden;
    clear: both;
  }

  .header-fixed>tbody {
    overflow-y: auto;
    height: var(--height-height);
  }

  .header-fixed>tbody>tr>td,
  .header-fixed>thead>tr>th {
    width: var(--cell-width);
    border: thin solid grey;
    float: left;
  }

  .td1{
    background:rgb(43, 255, 0) ;
  }
  .td2{
    background:red;
    color: white;
  }
  .td3{
    background:rgb(17, 0, 255) ;
  }
  .td4{
    background:rgb(235, 117, 6);
  }
  .td6{
    background:rgb(99, 101, 105) ;
    color: white;
  }


  .tdMonthDay_Width{
    max-width: 250px;
  }
  
  .tdMonthDay_Width_Greeb{
    background: #28a745d9;padding: 2px;margin: 5px;color: white;
  }

  .tdMonthDay_Width_Blue{
    background: #2848a7d9;padding: 2px;margin: 5px;color: white;
  }

  .tdMonthDay_Width_Red{
    background: #a74628d9;padding: 2px;margin: 5px;color: white;
  }

</style>

<div class="col-md-12 mb-30" [hidden]="WindowsSwitcher_Indexer!='List'">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <div class="float-left">
        <h5 class="card-title">
          برنامه ریزی

        </h5>
      </div>
      <div class="float-right">
        <select class="custom-select" [(ngModel)]="Show_Draft_LetterRequestCustomer"
          name="Show_Draft_LetterRequestCustomer">
          <option value="0">نمایش ماهانه</option>
          <option value="2">نمایش روزانه</option>
          <option value="1">نمایش کارشناس</option>
        </select>
      </div>

      <div style="clear: both;"></div>

      <br />
      <br />

      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">تاریخ شروع</label>
          <input type="text" #datepickerInputStart placeholder="اینجا تایپ کنید ..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">تاریخ پایان</label>
          <input type="text" #datepickerInputEnd placeholder="اینجا تایپ کنید ..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">نام مشتری </label>
          <input [(ngModel)]="Filter_customer" name="Filter_customer" type="text" class="form-control"
            placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1"> کاشناس </label>
          <app-ExpertCalibrationOption
            [inner_Expert_Lab]="true"
            (OnBack_ExpertCalibration_Action)="OnGet_ExpertCalibration_Action($event)">

          </app-ExpertCalibrationOption>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">محل فعالیت</label>
          <select class="custom-select" [(ngModel)]="ExpertCalibration_Type" name="ExpertCalibration_Type" >
            <option value="0">همه موارد</option>
            <option value="1">داخل آزمایشگاه</option>
            <option value="2">خارج آزمایشگاه</option>
            <option value="3">داخل/خارج آزمایشگاه</option>

          </select>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">نوع کارشناسان</label>
          <select class="custom-select" [(ngModel)]="showUnSchedule" name="showUnSchedule">
            <option value="0">کارشناسان دارای برنامه</option>
            <option value="1">همه کارشناسان</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-12">
          <button *ngIf="!Procssing" type="button"
            (click)="ReadData_Schedule(datepickerInputStart.value,datepickerInputEnd.value)" class="btn btn-info"
            style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
          <button *ngIf="!Procssing" type="button" (click)="ReadData_Month()" class="btn btn-success"
            style="margin-left: 5px;"><i class="fa  fa-search"></i> نمایش ماهانه </button>
          <button *ngIf="!Procssing" type="button" (click)="ReadData_15()" class="btn btn-danger"
              style="margin-left: 5px;"><i class="fa  fa-search"></i> نمایش 15 روز </button>
          <button *ngIf="!Procssing" type="button" (click)="ReadData_Week()" class="btn btn-warning"
            style="margin-left: 5px;"><i class="fa  fa-search"></i> نمایش هفته </button>
          <button *ngIf="!Procssing" type="button" (click)="ReadData_today()" class="btn btn-info"
            style="margin-left: 5px;"><i class="fa  fa-search"></i> نمایش روزانه </button>

          <button *ngIf="!Procssing" (click)="exportexcel()" type="button" class="btn btn-warning"
            style="margin-left: 5px;"><i class="fa   fa-file-excel-o"></i> Excel </button>
          <button *ngIf="!Procssing" (click)="exportexcelExpert()" type="button" class="btn btn-danger"
            style="margin-left: 5px;"><i class="fa   fa-file-excel-o"></i> Excel 2 </button>
          <button *ngIf="Procssing" type="button" class="btn btn-info" style="margin-left: 5px;"> لطفا صبر نمائید ... <i
              class="fa fa-spin fa-spinner"></i> </button>
        </div>
      </div>

      <div *ngIf="Show_Draft_LetterRequestCustomer=='2'" class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>تاریخ</th>
              <th>تاریخ به حروف</th>
              <th>برنامه</th>
            </tr>
          </thead>
          <tbody>

            <ng-container *ngFor="let item of DataList_Schedule">
              <tr style="cursor: pointer;">
                <td (click)="setSchuduleForProgramming(item)"  [ngClass]="{'MyErrorRedColor': item.offDay,'MyErrorBlueColor': item.canlender}">{{item.persianDate}}
                </td>
                <td (click)="setSchuduleForProgramming(item)"  [ngClass]="{'MyErrorRedColor': item.offDay,'MyErrorBlueColor': item.canlender}">
                  {{item.persianDate_Ful}}</td>

                <td>

                  <div class="row">
                    <ng-container *ngFor="let itemDetail of item.detail">
                        <div class="form-group col-md-6">
                          <a target="_blank" >
                            <div class="card card-statistics h-100" style="float: right;margin-left: 10px;">
                              <div class="card-body">
                                <div class="clearfix">

                                  <div title="در حال بررسی ماموریت" *ngIf="itemDetail.status==1" class="float-left icon-box bg-info  rounded-circle" style="width: 30px;height: 30px;">
                                    <span class="text-white">
                                      <i class="fa fa-info highlight-icon" style="font-size: 20px;line-height: 30px;" aria-hidden="true"></i>
                                    </span>
                                  </div>
                                  <div title="ماموریت انجام شد" *ngIf="itemDetail.status==2" class="float-left icon-box bg-success  rounded-circle" style="width: 30px;height: 30px;">
                                    <span class="text-white">
                                      <i class="fa fa-check highlight-icon" style="font-size: 20px;line-height: 30px;" aria-hidden="true"></i>
                                    </span>
                                  </div>
                                  <div title="ماموریت لغو شد" *ngIf="itemDetail.status==3" class="float-left icon-box bg-danger  rounded-circle" style="width: 30px;height: 30px;">
                                    <span class="text-white">
                                      <i class="fa fa-times-circle highlight-icon" style="font-size: 20px;line-height: 30px;" aria-hidden="true"></i>
                                    </span>
                                  </div>

                                  <a title="حکم ماموریت" href="{{BaseUrl}}{{itemDetail.letterId}}" target="_blank">
                                    <div  class="float-left icon-box bg-warning  rounded-circle" style="width: 30px;height: 30px;">
                                      <span class="text-white">
                                        <i class="fa fa-file-pdf-o highlight-icon" style="font-size: 20px;line-height: 30px;" aria-hidden="true"></i>
                                      </span>
                                    </div>
                                  </a>

                                  <div *ngIf="canSchedulingPDF" title="نمایش نامه صادره" [routerLink]="['/LetterRequestCustomerForm',{id:itemDetail.letterId}]" class="float-left icon-box bg-success  rounded-circle" style="width: 30px;height: 30px;">
                                    <span class="text-white">
                                      <i class="fa fa-file highlight-icon" style="font-size: 20px;line-height: 30px;" aria-hidden="true"></i>
                                    </span>
                                  </div>

                                  <div *ngIf="itemDetail.expert_Visible" title="عدم نمایش کارشناسان" (click)="Change_Visible_Expert(itemDetail)" class="float-left icon-box bg-info  rounded-circle" style="width: 30px;height: 30px;">
                                    <span class="text-white">
                                      <i class="fa fa-eye highlight-icon" style="font-size: 20px;line-height: 30px;" aria-hidden="true"></i>
                                    </span>
                                  </div>
                                  <div *ngIf="!itemDetail.expert_Visible" title="نمایش کارشناسان" (click)="Change_Visible_Expert(itemDetail)" class="float-left icon-box bg-info  rounded-circle" style="width: 30px;height: 30px;">
                                    <span class="text-white">
                                      <i class="fa fa-eye-slash highlight-icon" style="font-size: 20px;line-height: 30px;" aria-hidden="true"></i>
                                    </span>
                                  </div>

                                  <div *ngIf="itemDetail.file.length>0" (click)="openModalFileAttach(templateFileAttach,itemDetail)" title="فایل های ضمیمه" class="float-left icon-box bg-danger  rounded-circle" style="width: 30px;height: 30px;">
                                    <span class="text-white">
                                      <i class="fa fa-chain highlight-icon" style="font-size: 20px;line-height: 30px;" aria-hidden="true"></i>
                                    </span>
                                  </div>


                                  <div class="float-right text-right">
                                    <p class="card-text text-dark">شماره نامه {{itemDetail.letterId}}</p>
                                    <p class="card-text text-dark">شماره حکم {{itemDetail.code}}</p>
                                    <h6 style="font-size:1.0rem">{{itemDetail.customerName}}</h6>
                                    <p class="card-text text-dark">{{itemDetail.deviceCount}} دستگاه </p>





                                    <i style="margin: 10px;font-size: 16px;" class="fa fa-user-times"
                                      *ngIf="itemDetail.expertChange>0"></i>
                                    <i style="margin: 10px;font-size: 16px;" class="fa fa-times-rectangle-o"
                                      *ngIf="itemDetail.deviceChange>0"></i>
                                    <i style="margin: 10px;font-size: 16px;" class="fa fa-calendar-times-o"
                                      *ngIf="itemDetail.letterChange>0"></i>

                                  </div>

                                  <div style="clear: both;"></div>

                                  <table *ngIf="itemDetail.expert_Visible">
                                    <tr *ngFor="let itemDetailExpert of itemDetail.expert">
                                      <td> {{itemDetailExpert}}</td>
                                    </tr>
                                  </table>

                                </div>
                              </div>
                            </div>

                          </a>
                        </div>

                    </ng-container>
                  </div>


                </td>

              </tr>

            </ng-container>

          </tbody>
        </table>
      </div>

      <div *ngIf="Show_Draft_LetterRequestCustomer=='0'" class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>شنبه</th>
              <th>یکشنبه</th>
              <th>دوشنبه</th>
              <th>سه شنبه</th>
              <th>چهار شنبه</th>
              <th>پنج شنبه</th>
              <th>جمعه</th>

            </tr>
          </thead>
          <tbody>

            <ng-container *ngFor="let item of DataList_Schedule_2">
              <tr style="cursor: pointer;">
                <td [ngClass]="{'MyErrorRedColor': item.sat.offDay,'MyErrorBlueColor': item.sat.canlender}" style="width: 250px;text-align: center;padding: 5px;vertical-align: top;">
                  <div style="max-width: 250px;">
                    <p style="text-align: right;">{{item.sat.date}}</p>

                  </div>
                  <div *ngFor="let itemDetail of item.sat.detail" class="tdMonthDay_Width">
                    <div [ngClass]="{'tdMonthDay_Width_Blue': itemDetail.status==1,'tdMonthDay_Width_Greeb': itemDetail.status==2}">
                      <h6 style="font-size:1.0rem;color: white;">{{itemDetail.customerName}} ({{itemDetail.letterId}})</h6>


                      <div>
                        <a target="_blank"  [routerLink]="['/LetterRequestCustomerForm',{id:itemDetail.letterId}]">
                          <i class="fa fa-file" *ngIf="canSchedulingPDF" title="نمایش نامه صادره"></i>
                        </a>
                        <i class="fa fa-chain" style="margin-right: 10px;" *ngIf="itemDetail.file.length>0" (click)="openModalFileAttach(templateFileAttach,itemDetail)" title="فایل های ضمیمه" ></i>
                        
                        <i class="fa fa-eye" style="margin-right: 10px;" *ngIf="!itemDetail.expert_Visible" (click)="Change_Visible_Expert(itemDetail)" title="نمایش کارشناسان" ></i>
                        <i class="fa fa-eye-slash" style="margin-right: 10px;" *ngIf="itemDetail.expert_Visible" (click)="Change_Visible_Expert(itemDetail)"  title="عدم نمایش کارشناسان"></i>
                      </div>

                      <div *ngIf="itemDetail.expert_Visible" style="text-align: right;margin: 5px;">
                        <span *ngFor="let itemDetailExpert of itemDetail.expert">
                          <i class="fa fa-user"></i> {{itemDetailExpert}}
                          <br/>
                        </span>
                      </div>

                    </div>
                  </div>
                  <div *ngFor="let itemDetail of item.sat.schedule" class="tdMonthDay_Width">
                    <div class="tdMonthDay_Width_Red">
                      <h6 style="font-size:1.0rem;color: white;">{{itemDetail.customerName}}</h6>
                    </div>
                  </div>
                </td>

                <td [ngClass]="{'MyErrorRedColor': item.sun.offDay,'MyErrorBlueColor': item.sun.canlender}" style="width: 250px;text-align: center;padding: 5px;vertical-align: top;">
                  <div style="max-width: 250px;">
                    <p style="text-align: right;">{{item.sun.date}}</p>

                  </div>
                  <div *ngFor="let itemDetail of item.sun.detail" class="tdMonthDay_Width">
                    <div [ngClass]="{'tdMonthDay_Width_Blue': itemDetail.status==1,'tdMonthDay_Width_Greeb': itemDetail.status==2}">
                      <h6 style="font-size:1.0rem;color: white;">{{itemDetail.customerName}} ({{itemDetail.letterId}})</h6>


                      <div>
                        <a target="_blank"  [routerLink]="['/LetterRequestCustomerForm',{id:itemDetail.letterId}]">
                          <i class="fa fa-file" *ngIf="canSchedulingPDF" title="نمایش نامه صادره"></i>
                        </a>
                        <i class="fa fa-chain" style="margin-right: 10px;" *ngIf="itemDetail.file.length>0" (click)="openModalFileAttach(templateFileAttach,itemDetail)" title="فایل های ضمیمه" ></i>
                        
                        <i class="fa fa-eye" style="margin-right: 10px;" *ngIf="!itemDetail.expert_Visible" (click)="Change_Visible_Expert(itemDetail)" title="نمایش کارشناسان" ></i>
                        <i class="fa fa-eye-slash" style="margin-right: 10px;" *ngIf="itemDetail.expert_Visible" (click)="Change_Visible_Expert(itemDetail)"  title="عدم نمایش کارشناسان"></i>
                      </div>

                      <div *ngIf="itemDetail.expert_Visible" style="text-align: right;margin: 5px;">
                        <span *ngFor="let itemDetailExpert of itemDetail.expert">
                          <i class="fa fa-user"></i> {{itemDetailExpert}}
                          <br/>
                        </span>
                      </div>

                    </div>
                  </div>
                  <div *ngFor="let itemDetail of item.sun.schedule" class="tdMonthDay_Width">
                    <div class="tdMonthDay_Width_Red">
                      <h6 style="font-size:1.0rem;color: white;">{{itemDetail.customerName}}</h6>
                    </div>
                  </div>
                </td>

                <td [ngClass]="{'MyErrorRedColor': item.mon.offDay,'MyErrorBlueColor': item.mon.canlender}" style="width: 250px;text-align: center;padding: 5px;vertical-align: top;">
                  <div style="max-width: 250px;">
                    <p style="text-align: right;">{{item.mon.date}}</p>

                  </div>
                  <div *ngFor="let itemDetail of item.mon.detail" class="tdMonthDay_Width">
                    <div [ngClass]="{'tdMonthDay_Width_Blue': itemDetail.status==1,'tdMonthDay_Width_Greeb': itemDetail.status==2}">
                      <h6 style="font-size:1.0rem;color: white;">{{itemDetail.customerName}} ({{itemDetail.letterId}})</h6>


                      <div>
                        <a target="_blank"  [routerLink]="['/LetterRequestCustomerForm',{id:itemDetail.letterId}]">
                          <i class="fa fa-file" *ngIf="canSchedulingPDF" title="نمایش نامه صادره"></i>
                        </a>
                        <i class="fa fa-chain" style="margin-right: 10px;" *ngIf="itemDetail.file.length>0" (click)="openModalFileAttach(templateFileAttach,itemDetail)" title="فایل های ضمیمه" ></i>
                        
                        <i class="fa fa-eye" style="margin-right: 10px;" *ngIf="!itemDetail.expert_Visible" (click)="Change_Visible_Expert(itemDetail)" title="نمایش کارشناسان" ></i>
                        <i class="fa fa-eye-slash" style="margin-right: 10px;" *ngIf="itemDetail.expert_Visible" (click)="Change_Visible_Expert(itemDetail)"  title="عدم نمایش کارشناسان"></i>
                      </div>

                      <div *ngIf="itemDetail.expert_Visible" style="text-align: right;margin: 5px;">
                        <span *ngFor="let itemDetailExpert of itemDetail.expert">
                          <i class="fa fa-user"></i> {{itemDetailExpert}}
                          <br/>
                        </span>
                      </div>

                    </div>
                  </div>
                  <div *ngFor="let itemDetail of item.mon.schedule" class="tdMonthDay_Width">
                    <div class="tdMonthDay_Width_Red">
                      <h6 style="font-size:1.0rem;color: white;">{{itemDetail.customerName}}</h6>
                    </div>
                  </div>
                </td>


                <td [ngClass]="{'MyErrorRedColor': item.tus.offDay,'MyErrorBlueColor': item.tus.canlender}" style="width: 250px;text-align: center;padding: 5px;vertical-align: top;">
                  <div style="max-width: 250px;">
                    <p style="text-align: right;">{{item.tus.date}}</p>

                  </div>
                  <div *ngFor="let itemDetail of item.tus.detail" class="tdMonthDay_Width">
                    <div [ngClass]="{'tdMonthDay_Width_Blue': itemDetail.status==1,'tdMonthDay_Width_Greeb': itemDetail.status==2}">
                      <h6 style="font-size:1.0rem;color: white;">{{itemDetail.customerName}} ({{itemDetail.letterId}})</h6>


                      <div>
                        <a target="_blank"  [routerLink]="['/LetterRequestCustomerForm',{id:itemDetail.letterId}]">
                          <i class="fa fa-file" *ngIf="canSchedulingPDF" title="نمایش نامه صادره"></i>
                        </a>
                        <i class="fa fa-chain" style="margin-right: 10px;" *ngIf="itemDetail.file.length>0" (click)="openModalFileAttach(templateFileAttach,itemDetail)" title="فایل های ضمیمه" ></i>
                        
                        <i class="fa fa-eye" style="margin-right: 10px;" *ngIf="!itemDetail.expert_Visible" (click)="Change_Visible_Expert(itemDetail)" title="نمایش کارشناسان" ></i>
                        <i class="fa fa-eye-slash" style="margin-right: 10px;" *ngIf="itemDetail.expert_Visible" (click)="Change_Visible_Expert(itemDetail)"  title="عدم نمایش کارشناسان"></i>
                      </div>

                      <div *ngIf="itemDetail.expert_Visible" style="text-align: right;margin: 5px;">
                        <span *ngFor="let itemDetailExpert of itemDetail.expert">
                          <i class="fa fa-user"></i> {{itemDetailExpert}}
                          <br/>
                        </span>
                      </div>

                    </div>
                  </div>
                  <div *ngFor="let itemDetail of item.tus.schedule" class="tdMonthDay_Width">
                    <div class="tdMonthDay_Width_Red">
                      <h6 style="font-size:1.0rem;color: white;">{{itemDetail.customerName}}</h6>
                    </div>
                  </div>
                </td>

                <td [ngClass]="{'MyErrorRedColor': item.wens.offDay,'MyErrorBlueColor': item.wens.canlender}" style="width: 250px;text-align: center;padding: 5px;vertical-align: top;">
                  <div style="max-width: 250px;">
                    <p style="text-align: right;">{{item.wens.date}}</p>

                  </div>
                  <div *ngFor="let itemDetail of item.wens.detail" class="tdMonthDay_Width">
                    <div [ngClass]="{'tdMonthDay_Width_Blue': itemDetail.status==1,'tdMonthDay_Width_Greeb': itemDetail.status==2}">
                      <h6 style="font-size:1.0rem;color: white;">{{itemDetail.customerName}} ({{itemDetail.letterId}})</h6>


                      <div>
                        <a target="_blank"  [routerLink]="['/LetterRequestCustomerForm',{id:itemDetail.letterId}]">
                          <i class="fa fa-file" *ngIf="canSchedulingPDF" title="نمایش نامه صادره"></i>
                        </a>
                        <i class="fa fa-chain" style="margin-right: 10px;" *ngIf="itemDetail.file.length>0" (click)="openModalFileAttach(templateFileAttach,itemDetail)" title="فایل های ضمیمه" ></i>
                        
                        <i class="fa fa-eye" style="margin-right: 10px;" *ngIf="!itemDetail.expert_Visible" (click)="Change_Visible_Expert(itemDetail)" title="نمایش کارشناسان" ></i>
                        <i class="fa fa-eye-slash" style="margin-right: 10px;" *ngIf="itemDetail.expert_Visible" (click)="Change_Visible_Expert(itemDetail)"  title="عدم نمایش کارشناسان"></i>
                      </div>

                      <div *ngIf="itemDetail.expert_Visible" style="text-align: right;margin: 5px;">
                        <span *ngFor="let itemDetailExpert of itemDetail.expert">
                          <i class="fa fa-user"></i> {{itemDetailExpert}}
                          <br/>
                        </span>
                      </div>

                    </div>
                  </div>
                  <div *ngFor="let itemDetail of item.wens.schedule" class="tdMonthDay_Width">
                    <div class="tdMonthDay_Width_Red">
                      <h6 style="font-size:1.0rem;color: white;">{{itemDetail.customerName}}</h6>
                    </div>
                  </div>
                </td>

                <td [ngClass]="{'MyErrorRedColor': item.thus.offDay,'MyErrorBlueColor': item.thus.canlender}" style="width: 250px;text-align: center;padding: 5px;vertical-align: top;">
                  <div style="max-width: 250px;">
                    <p style="text-align: right;">{{item.thus.date}}</p>

                  </div>
                  <div *ngFor="let itemDetail of item.thus.detail" class="tdMonthDay_Width">
                    <div [ngClass]="{'tdMonthDay_Width_Blue': itemDetail.status==1,'tdMonthDay_Width_Greeb': itemDetail.status==2}">
                      <h6 style="font-size:1.0rem;color: white;">{{itemDetail.customerName}} ({{itemDetail.letterId}})</h6>


                      <div>
                        <a target="_blank"  [routerLink]="['/LetterRequestCustomerForm',{id:itemDetail.letterId}]">
                          <i class="fa fa-file" *ngIf="canSchedulingPDF" title="نمایش نامه صادره"></i>
                        </a>
                        <i class="fa fa-chain" style="margin-right: 10px;" *ngIf="itemDetail.file.length>0" (click)="openModalFileAttach(templateFileAttach,itemDetail)" title="فایل های ضمیمه" ></i>
                        
                        <i class="fa fa-eye" style="margin-right: 10px;" *ngIf="!itemDetail.expert_Visible" (click)="Change_Visible_Expert(itemDetail)" title="نمایش کارشناسان" ></i>
                        <i class="fa fa-eye-slash" style="margin-right: 10px;" *ngIf="itemDetail.expert_Visible" (click)="Change_Visible_Expert(itemDetail)"  title="عدم نمایش کارشناسان"></i>
                      </div>

                      <div *ngIf="itemDetail.expert_Visible" style="text-align: right;margin: 5px;">
                        <span *ngFor="let itemDetailExpert of itemDetail.expert">
                          <i class="fa fa-user"></i> {{itemDetailExpert}}
                          <br/>
                        </span>
                      </div>

                    </div>
                  </div>
                  <div *ngFor="let itemDetail of item.thus.schedule" class="tdMonthDay_Width">
                    <div class="tdMonthDay_Width_Red">
                      <h6 style="font-size:1.0rem;color: white;">{{itemDetail.customerName}}</h6>
                    </div>
                  </div>
                </td>
                
                
                <td [ngClass]="{'MyErrorRedColor': item.fri.offDay,'MyErrorBlueColor': item.fri.canlender}" style="width: 250px;text-align: center;padding: 5px;vertical-align: top;">
                  <div style="max-width: 250px;">
                    <p style="text-align: right;">{{item.fri.date}}</p>

                  </div>
                  <div *ngFor="let itemDetail of item.fri.detail" class="tdMonthDay_Width">
                    <div [ngClass]="{'tdMonthDay_Width_Blue': itemDetail.status==1,'tdMonthDay_Width_Greeb': itemDetail.status==2}">
                      <h6 style="font-size:1.0rem;color: white;">{{itemDetail.customerName}} ({{itemDetail.letterId}})</h6>


                      <div>
                        <a target="_blank"  [routerLink]="['/LetterRequestCustomerForm',{id:itemDetail.letterId}]">
                          <i class="fa fa-file" *ngIf="canSchedulingPDF" title="نمایش نامه صادره"></i>
                        </a>
                        <i class="fa fa-chain" style="margin-right: 10px;" *ngIf="itemDetail.file.length>0" (click)="openModalFileAttach(templateFileAttach,itemDetail)" title="فایل های ضمیمه" ></i>
                        
                        <i class="fa fa-eye" style="margin-right: 10px;" *ngIf="!itemDetail.expert_Visible" (click)="Change_Visible_Expert(itemDetail)" title="نمایش کارشناسان" ></i>
                        <i class="fa fa-eye-slash" style="margin-right: 10px;" *ngIf="itemDetail.expert_Visible" (click)="Change_Visible_Expert(itemDetail)"  title="عدم نمایش کارشناسان"></i>
                      </div>

                      <div *ngIf="itemDetail.expert_Visible" style="text-align: right;margin: 5px;">
                        <span *ngFor="let itemDetailExpert of itemDetail.expert">
                          <i class="fa fa-user"></i> {{itemDetailExpert}}
                          <br/>
                        </span>
                      </div>

                    </div>
                  </div>
                  <div *ngFor="let itemDetail of item.fri.schedule" class="tdMonthDay_Width">
                    <div class="tdMonthDay_Width_Red">
                      <h6 style="font-size:1.0rem;color: white;">{{itemDetail.customerName}}</h6>
                    </div>
                  </div>
                </td>




              </tr>

            </ng-container>

          </tbody>
        </table>
      </div>


      <div *ngIf="Show_Draft_LetterRequestCustomer=='1'" class="table-responsive header-fixed">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr  (click)="setSchuduleForProgramming(item)">
              <td>{{DataList_Schedule_Expert_Uniq[0]['persianDate']}}</td>
              <td>{{DataList_Schedule_Expert_Uniq[0]['fullDate']}}</td>
              <td *ngIf="DataList_Schedule_Expert_Uniq[0]['e1']" >{{DataList_Schedule_Expert_Uniq[0]['e1']}}</td>
              <td *ngIf="DataList_Schedule_Expert_Uniq[0]['e2']">{{DataList_Schedule_Expert_Uniq[0]['e2']}}</td>
              <td *ngIf="DataList_Schedule_Expert_Uniq[0]['e3']">{{DataList_Schedule_Expert_Uniq[0]['e3']}}</td>
              <td *ngIf="DataList_Schedule_Expert_Uniq[0]['e4']">{{DataList_Schedule_Expert_Uniq[0]['e4']}}</td>
              <td *ngIf="DataList_Schedule_Expert_Uniq[0]['e5']">{{DataList_Schedule_Expert_Uniq[0]['e5']}}</td>
              <td *ngIf="DataList_Schedule_Expert_Uniq[0]['e6']">{{DataList_Schedule_Expert_Uniq[0]['e6']}}</td>
              <td *ngIf="DataList_Schedule_Expert_Uniq[0]['e7']">{{DataList_Schedule_Expert_Uniq[0]['e7']}}</td>
              <td *ngIf="DataList_Schedule_Expert_Uniq[0]['e8']">{{DataList_Schedule_Expert_Uniq[0]['e8']}}</td>
              <td *ngIf="DataList_Schedule_Expert_Uniq[0]['e9']">{{DataList_Schedule_Expert_Uniq[0]['e9']}}</td>
              <td *ngIf="DataList_Schedule_Expert_Uniq[0]['e10']">{{DataList_Schedule_Expert_Uniq[0]['e10']}}</td>
              <td *ngIf="DataList_Schedule_Expert_Uniq[0]['e11']">{{DataList_Schedule_Expert_Uniq[0]['e11']}}</td>
              <td *ngIf="DataList_Schedule_Expert_Uniq[0]['e12']">{{DataList_Schedule_Expert_Uniq[0]['e12']}}</td>
              <td *ngIf="DataList_Schedule_Expert_Uniq[0]['e13']">{{DataList_Schedule_Expert_Uniq[0]['e13']}}</td>
              <td *ngIf="DataList_Schedule_Expert_Uniq[0]['e14']">{{DataList_Schedule_Expert_Uniq[0]['e14']}}</td>
              <td *ngIf="DataList_Schedule_Expert_Uniq[0]['e15']">{{DataList_Schedule_Expert_Uniq[0]['e15']}}</td>
              <td *ngIf="DataList_Schedule_Expert_Uniq[0]['e16']">{{DataList_Schedule_Expert_Uniq[0]['e16']}}</td>
              <td *ngIf="DataList_Schedule_Expert_Uniq[0]['e17']">{{DataList_Schedule_Expert_Uniq[0]['e17']}}</td>
              <td *ngIf="DataList_Schedule_Expert_Uniq[0]['e18']">{{DataList_Schedule_Expert_Uniq[0]['e18']}}</td>
              <td *ngIf="DataList_Schedule_Expert_Uniq[0]['e19']">{{DataList_Schedule_Expert_Uniq[0]['e19']}}</td>
              <td *ngIf="DataList_Schedule_Expert_Uniq[0]['e20']">{{DataList_Schedule_Expert_Uniq[0]['e20']}}</td>
            </tr>
          </thead>
          <tbody>

            <ng-container *ngFor="let item of DataList_Schedule_Expert_Uniq">

              <tr *ngIf="DataList_Schedule_Expert_Uniq.indexOf(item)>0">
                <td [ngClass]="{'MyErrorRedColor': item['offDay'],'MyErrorBlueColor': item['canlender']}">
                  {{item['persianDate']}}</td>
                <td [ngClass]="{'MyErrorRedColor': item['offDay'],'MyErrorBlueColor': item['canlender']}">
                  {{item['fullDate']}}</td>
                <td [ngClass]="{'td1': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][0]===1,
                                'td2': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][0]===2,
                                'td3': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][0]===3,
                                'td4': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][0]===4,
                                'td6': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][0]===6}"

                    *ngIf="DataList_Schedule_Expert_Uniq[0]['e1']" (click)="OnSet_Scheduling(0,item['persianDate'])">

                  <ul *ngFor="let item_detail of item['e1'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>

                <td [ngClass]="{'td1': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][1]===1,
                                'td2': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][1]===2,
                                'td3': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][1]===3,
                                'td4': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][1]===4,
                                'td6': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][1]===6}"

                    *ngIf="DataList_Schedule_Expert_Uniq[0]['e2']" (click)="OnSet_Scheduling(1,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e2'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>

                <td [ngClass]="{'td1': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][2]===1,
                                'td2': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][2]===2,
                                'td3': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][2]===3,
                                'td4': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][2]===4,
                                'td6': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][2]===6}"
                   *ngIf="DataList_Schedule_Expert_Uniq[0]['e3']" (click)="OnSet_Scheduling(2,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e3'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}} </li>
                  </ul>
                </td>

                <td [ngClass]="{'td1': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][3]===1,
                                'td2': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][3]===2,
                                'td3': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][3]===3,
                                'td4': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][3]===4,
                                'td6': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][3]===6}"
                    *ngIf="DataList_Schedule_Expert_Uniq[0]['e4']" (click)="OnSet_Scheduling(3,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e4'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>

                <td [ngClass]="{'td1': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][4]===1,
                                'td2': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][4]===2,
                                'td3': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][4]===3,
                                'td4': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][4]===4,
                                'td6': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][4]===6}"
                   *ngIf="DataList_Schedule_Expert_Uniq[0]['e5']" (click)="OnSet_Scheduling(4,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e5'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>

                <td [ngClass]="{'td1': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][5]===1,
                                'td2': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][5]===2,
                                'td3': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][5]===3,
                                'td4': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][5]===4,
                                'td6': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][5]===6}"
                                *ngIf="DataList_Schedule_Expert_Uniq[0]['e6']" (click)="OnSet_Scheduling(5,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e6'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>

                <td [ngClass]="{'td1': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][6]===1,
                                'td2': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][6]===2,
                                'td3': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][6]===3,
                                'td4': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][6]===4,
                                'td6': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][6]===6}"
                                *ngIf="DataList_Schedule_Expert_Uniq[0]['e7']" (click)="OnSet_Scheduling(6,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e7'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>

                <td [ngClass]="{'td1': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][7]===1,
                                'td2': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][7]===2,
                                'td3': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][7]===3,
                                'td4': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][7]===4,
                                'td6': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][7]===6}"
                   *ngIf="DataList_Schedule_Expert_Uniq[0]['e8']" (click)="OnSet_Scheduling(7,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e8'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>

                <td [ngClass]="{'td1': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][8]===1,
                                'td2': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][8]===2,
                                'td3': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][8]===3,
                                'td4': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][8]===4,
                                'td6': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][8]===6}"
                                *ngIf="DataList_Schedule_Expert_Uniq[0]['e9']" (click)="OnSet_Scheduling(8,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e9'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>

                <td [ngClass]="{'td1': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][9]===1,
                                'td2': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][9]===2,
                                'td3': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][9]===3,
                                'td4': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][9]===4,
                                'td6': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][9]===6}"
                                *ngIf="DataList_Schedule_Expert_Uniq[0]['e10']" (click)="OnSet_Scheduling(9,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e10'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>

                <td [ngClass]="{'td1': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][10]===1,
                                'td2': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][10]===2,
                                'td3': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][10]===3,
                                'td4': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][10]===4,
                                'td6': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][10]===6}"
                                *ngIf="DataList_Schedule_Expert_Uniq[0]['e11']" (click)="OnSet_Scheduling(10,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e11'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>

                <td [ngClass]="{'td1': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][11]===1,
                                'td2': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][11]===2,
                                'td3': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][11]===3,
                                'td4': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][11]===4,
                                'td6': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][11]===6}"
                                *ngIf="DataList_Schedule_Expert_Uniq[0]['e12']" (click)="OnSet_Scheduling(11,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e12'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>

                <td [ngClass]="{'td1': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][12]===1,
                                'td2': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][12]===2,
                                'td3': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][12]===3,
                                'td4': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][12]===4,
                                'td6': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][12]===6}"
                                *ngIf="DataList_Schedule_Expert_Uniq[0]['e13']" (click)="OnSet_Scheduling(12,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e13'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>

                <td [ngClass]="{'td1': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][13]===1,
                                'td2': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][13]===2,
                                'td3': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][13]===3,
                                'td4': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][13]===4,
                                'td6': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][13]===6}"
                                *ngIf="DataList_Schedule_Expert_Uniq[0]['e14']" (click)="OnSet_Scheduling(13,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e14'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>

                <td [ngClass]="{'td1': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][14]===1,
                                'td2': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][14]===2,
                                'td3': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][14]===3,
                                'td4': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][14]===4,
                                'td6': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][14]===6}"
                                *ngIf="DataList_Schedule_Expert_Uniq[0]['e15']" (click)="OnSet_Scheduling(14,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e15'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>

                <td [ngClass]="{'td1': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][15]===1,
                                'td2': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][15]===2,
                                'td3': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][15]===3,
                                'td4': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][15]===4,
                                'td6': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][15]===6}"
                                *ngIf="DataList_Schedule_Expert_Uniq[0]['e16']" (click)="OnSet_Scheduling(15,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e16'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>

                <td [ngClass]="{'td1': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][16]===1,
                                'td2': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][16]===2,
                                'td3': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][16]===3,
                                'td4': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][16]===4,
                                'td6': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][16]===6}"
                                 *ngIf="DataList_Schedule_Expert_Uniq[0]['e17']" (click)="OnSet_Scheduling(16,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e17'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>

                <td [ngClass]="{'td1': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][17]===1,
                                'td2': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][17]===2,
                                'td3': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][17]===3,
                                'td4': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][17]===4,
                                'td6': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][17]===6}"
                 *ngIf="DataList_Schedule_Expert_Uniq[0]['e18']" (click)="OnSet_Scheduling(17,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e18'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>

                <td [ngClass]="{'td1': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][18]===1,
                                'td2': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][18]===2,
                                'td3': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][18]===3,
                                'td4': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][18]===4,
                                'td6': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][18]===6}"
                 *ngIf="DataList_Schedule_Expert_Uniq[0]['e19']" (click)="OnSet_Scheduling(18,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e19'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>

                <td [ngClass]="{'td1': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][19]===1,
                                'td2': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][19]===2,
                                'td3': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][19]===3,
                                'td4': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][19]===4,
                                'td6': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][19]===6}"
                                *ngIf="DataList_Schedule_Expert_Uniq[0]['e20']" (click)="OnSet_Scheduling(19,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e20'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>

                <td [ngClass]="{'td1': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][20]===1,
                                'td2': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][20]===2,
                                'td3': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][20]===3,
                                'td4': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][20]===4,
                                'td6': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][20]===6}"
                                *ngIf="DataList_Schedule_Expert_Uniq[0]['e21']" (click)="OnSet_Scheduling(20,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e21'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>

                <td [ngClass]="{'td1': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][21]===1,
                                'td2': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][21]===2,
                                'td3': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][21]===3,
                                'td4': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][21]===4,
                                'td6': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][21]===6}"
                                *ngIf="DataList_Schedule_Expert_Uniq[0]['e22']" (click)="OnSet_Scheduling(21,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e22'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>

                <td [ngClass]="{'td1': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][22]===1,
                                'td2': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][22]===2,
                                'td3': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][22]===3,
                                'td4': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][22]===4,
                                'td6': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][22]===6}"
                                *ngIf="DataList_Schedule_Expert_Uniq[0]['e23']" (click)="OnSet_Scheduling(22,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e23'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>

                <td [ngClass]="{'td1': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][23]===1,
                                'td2': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][23]===2,
                                'td3': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][23]===3,
                                'td4': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][23]===4,
                                'td6': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][23]===6}"
                                *ngIf="DataList_Schedule_Expert_Uniq[0]['e24']" (click)="OnSet_Scheduling(23,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e24'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>

                <td [ngClass]="{'td1': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][24]===1,
                                'td2': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][24]===2,
                                'td3': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][24]===3,
                                'td4': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][24]===4,
                                'td6': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][24]===6}"
                                *ngIf="DataList_Schedule_Expert_Uniq[0]['e25']" (click)="OnSet_Scheduling(24,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e25'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>

                <td [ngClass]="{'td1': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][25]===1,
                                'td2': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][25]===2,
                                'td3': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][25]===3,
                                'td4': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][25]===4,
                                'td6': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][25]===6}"
                                *ngIf="DataList_Schedule_Expert_Uniq[0]['e26']" (click)="OnSet_Scheduling(25,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e26'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>

                <td [ngClass]="{'td1': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][26]===1,
                                'td2': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][26]===2,
                                'td3': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][26]===3,
                                'td4': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][26]===4,
                                'td6': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][26]===6}"
                                *ngIf="DataList_Schedule_Expert_Uniq[0]['e27']" (click)="OnSet_Scheduling(26,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e27'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>

                <td [ngClass]="{'td1': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][27]===1,
                                'td2': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][27]===2,
                                'td3': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][27]===3,
                                'td4': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][27]===4,
                                'td6': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][27]===6}"
                                *ngIf="DataList_Schedule_Expert_Uniq[0]['e28']" (click)="OnSet_Scheduling(27,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e28'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>

                <td [ngClass]="{'td1': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][28]===1,
                                'td2': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][28]===2,
                                'td3': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][28]===3,
                                'td4': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][28]===4,
                                'td6': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][28]===6}"
                                *ngIf="DataList_Schedule_Expert_Uniq[0]['e29']" (click)="OnSet_Scheduling(28,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e29'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>

                <td [ngClass]="{'td1': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][29]===1,
                                'td2': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][29]===2,
                                'td3': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][29]===3,
                                'td4': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][29]===4,
                                'td6': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][29]===6}"
                                *ngIf="DataList_Schedule_Expert_Uniq[0]['e30']" (click)="OnSet_Scheduling(29,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e30'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>

                <td [ngClass]="{'td1': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][30]===1,
                                'td2': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][30]===2,
                                'td3': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][30]===3,
                                'td4': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][30]===4,
                                'td6': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][30]===6}"
                                *ngIf="DataList_Schedule_Expert_Uniq[0]['e31']" (click)="OnSet_Scheduling(30,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e31'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>

                <td [ngClass]="{'td1': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][31]===1,
                                'td2': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][31]===2,
                                'td3': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][31]===3,
                                'td4': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][31]===4,
                                'td6': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][31]===6}"
                                *ngIf="DataList_Schedule_Expert_Uniq[0]['e32']" (click)="OnSet_Scheduling(31,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e32'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>

                <td [ngClass]="{'td1': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][32]===1,
                                'td2': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][32]===2,
                                'td3': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][32]===3,
                                'td4': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][32]===4,
                                'td6': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][32]===6}"
                                *ngIf="DataList_Schedule_Expert_Uniq[0]['e33']" (click)="OnSet_Scheduling(32,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e33'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>

                <td [ngClass]="{'td1': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][33]===1,
                                'td2': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][33]===2,
                                'td3': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][33]===3,
                                'td4': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][33]===4,
                                'td6': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][33]===6}"
                                *ngIf="DataList_Schedule_Expert_Uniq[0]['e34']" (click)="OnSet_Scheduling(33,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e34'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>

                <td [ngClass]="{'td1': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][34]===1,
                                'td2': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][34]===2,
                                'td3': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][34]===3,
                                'td4': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][34]===4,
                                'td6': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][34]===6}"
                                *ngIf="DataList_Schedule_Expert_Uniq[0]['e35']" (click)="OnSet_Scheduling(34,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e35'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>

                <td [ngClass]="{'td1': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][35]===1,
                                'td2': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][35]===2,
                                'td3': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][35]===3,
                                'td4': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][35]===4,
                                'td6': DataList_Schedule_Expert_Uniq_Color[DataList_Schedule_Expert_Uniq.indexOf(item)][35]===6}"
                                *ngIf="DataList_Schedule_Expert_Uniq[0]['e36']" (click)="OnSet_Scheduling(35,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e36'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>
                <td *ngIf="DataList_Schedule_Expert_Uniq[0]['e37']" (click)="OnSet_Scheduling(36,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e37'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>
                <td *ngIf="DataList_Schedule_Expert_Uniq[0]['e38']" (click)="OnSet_Scheduling(37,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e38'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>
                <td *ngIf="DataList_Schedule_Expert_Uniq[0]['e39']" (click)="OnSet_Scheduling(38,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e39'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>
                <td *ngIf="DataList_Schedule_Expert_Uniq[0]['e40']" (click)="OnSet_Scheduling(39,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e40'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>
                <td *ngIf="DataList_Schedule_Expert_Uniq[0]['e41']" (click)="OnSet_Scheduling(40,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e41'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>
                <td *ngIf="DataList_Schedule_Expert_Uniq[0]['e42']" (click)="OnSet_Scheduling(41,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e42'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>
                <td *ngIf="DataList_Schedule_Expert_Uniq[0]['e43']" (click)="OnSet_Scheduling(42,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e43'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>
                <td *ngIf="DataList_Schedule_Expert_Uniq[0]['e44']" (click)="OnSet_Scheduling(43,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e44'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>
                <td *ngIf="DataList_Schedule_Expert_Uniq[0]['e45']" (click)="OnSet_Scheduling(44,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e45'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>
                <td *ngIf="DataList_Schedule_Expert_Uniq[0]['e46']" (click)="OnSet_Scheduling(45,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e46'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>
                <td *ngIf="DataList_Schedule_Expert_Uniq[0]['e47']" (click)="OnSet_Scheduling(46,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e47'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>
                <td *ngIf="DataList_Schedule_Expert_Uniq[0]['e48']" (click)="OnSet_Scheduling(47,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e48'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>
                <td *ngIf="DataList_Schedule_Expert_Uniq[0]['e49']" (click)="OnSet_Scheduling(48,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e4'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>
                <td *ngIf="DataList_Schedule_Expert_Uniq[0]['e50']" (click)="OnSet_Scheduling(49,item['persianDate'])">
                  <ul *ngFor="let item_detail of item['e4'].split(',')">
                    <li *ngIf="item_detail">{{item_detail}}</li>
                  </ul>
                </td>
              </tr>

            </ng-container>



          </tbody>

        </table>
      </div>

    </div>

  </div>
</div>

<div *ngIf="WindowsSwitcher_Indexer=='Form'">
  <app-LetterRequestCustomerScheduleForm
    [inner_Record]="Selected_ScheduleTable_Record">

  </app-LetterRequestCustomerScheduleForm>

  <button (click)="BackToList()" type="button" class="btn btn-warning"><i
    class="fa fa-mail-reply"></i> بازگشت </button>
</div>

<div *ngIf="WindowsSwitcher_Indexer=='Schedule'">
  <app-ScheduleForm
    [inner_expert_id]="Schedule_Expert_Id"
    [inner_expert_title]="Schedule_Expert_Title"
    [inner_persianDate]="Schedule_Persian_Date"
    (OnBack_Action)="BackToList()"
    >

  </app-ScheduleForm>

</div>

<table id="excel-table" style="display: none;">
  <thead>
    <tr>
      <th>#</th>
      <th>تاریخ</th>
      <th>تاریخ به حروف</th>
      <th>برنامه 1</th>
      <th>برنامه 2</th>
      <th>برنامه 3</th>
      <th>برنامه 4</th>
      <th>برنامه 5</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of DataList_Schedule">
      <td>{{DataList_Schedule.indexOf(item)+1}}</td>
      <td>{{item.persianDate}}</td>
      <td>{{item.persianDate_Ful}}</td>



      <td>
        <p *ngIf="item.detail[0]">

          <span *ngIf="item.detail[0].status==1"> {{item.detail[0].letterId}} - {{item.detail[0].customerNameFull}} -
            برنامه ریزی شد </span>
          <span *ngIf="item.detail[0].status==2"> {{item.detail[0].letterId}} - {{item.detail[0].customerNameFull}} -
            انجام شد </span>
          <span *ngIf="item.detail[0].status==3"> {{item.detail[0].letterId}} - {{item.detail[0].customerNameFull}} -
            لغو شد </span>

        </p>
      </td>

      <td>
        <p *ngIf="item.detail[1]">
          <span *ngIf="item.detail[1].status==1"> {{item.detail[1].letterId}} - {{item.detail[1].customerNameFull}} -
            برنامه ریزی شد </span>
          <span *ngIf="item.detail[1].status==2"> {{item.detail[1].letterId}} - {{item.detail[1].customerNameFull}} -
            انجام شد </span>
          <span *ngIf="item.detail[1].status==3"> {{item.detail[1].letterId}} - {{item.detail[1].customerNameFull}} -
            لغو شد </span>
        </p>
      </td>

      <td>
        <p *ngIf="item.detail[2]">
          <span *ngIf="item.detail[2].status==1"> {{item.detail[2].letterId}} - {{item.detail[2].customerNameFull}} -
            برنامه ریزی شد </span>
          <span *ngIf="item.detail[2].status==2"> {{item.detail[2].letterId}} - {{item.detail[2].customerNameFull}} -
            انجام شد </span>
          <span *ngIf="item.detail[2].status==3"> {{item.detail[2].letterId}} - {{item.detail[2].customerNameFull}} -
            لغو شد </span>
        </p>
      </td>

      <td>
        <p *ngIf="item.detail[3]">
          <span *ngIf="item.detail[3].status==1"> {{item.detail[3].letterId}} - {{item.detail[3].customerNameFull}} -
            برنامه ریزی شد </span>
          <span *ngIf="item.detail[3].status==2"> {{item.detail[3].letterId}} - {{item.detail[3].customerNameFull}} -
            انجام شد </span>
          <span *ngIf="item.detail[3].status==3"> {{item.detail[3].letterId}} - {{item.detail[3].customerNameFull}} -
            لغو شد </span>
        </p>
      </td>

      <td>
        <p *ngIf="item.detail[4]">
          <span *ngIf="item.detail[4].status==1"> {{item.detail[4].letterId}} - {{item.detail[4].customerNameFull}} -
            برنامه ریزی شد </span>
          <span *ngIf="item.detail[4].status==2"> {{item.detail[4].letterId}} - {{item.detail[4].customerNameFull}} -
            انجام شد </span>
          <span *ngIf="item.detail[4].status==3"> {{item.detail[4].letterId}} - {{item.detail[4].customerNameFull}} -
            لغو شد </span>
        </p>
      </td>


    </tr>
  </tbody>
</table>

<table id="excel-table-Expert" style="display: none;">
  <tr *ngFor="let item of DataList_Schedule_Expert_Uniq">
    <td>{{item['persianDate']}}</td>
    <td>{{item['fullDate']}}</td>
    <td>{{item['e1']}}</td>
    <td>{{item['e2']}}</td>
    <td>{{item['e3']}}</td>
    <td>{{item['e4']}}</td>
    <td>{{item['e5']}}</td>
    <td>{{item['e6']}}</td>
    <td>{{item['e7']}}</td>
    <td>{{item['e8']}}</td>
    <td>{{item['e9']}}</td>
    <td>{{item['e10']}}</td>
    <td>{{item['e11']}}</td>
    <td>{{item['e12']}}</td>
    <td>{{item['e13']}}</td>
    <td>{{item['e14']}}</td>
    <td>{{item['e15']}}</td>
    <td>{{item['e16']}}</td>
    <td>{{item['e17']}}</td>
    <td>{{item['e18']}}</td>
    <td>{{item['e19']}}</td>
    <td>{{item['e20']}}</td>
    <td>{{item['e21']}}</td>
    <td>{{item['e22']}}</td>
    <td>{{item['e23']}}</td>
    <td>{{item['e24']}}</td>
    <td>{{item['e25']}}</td>
    <td>{{item['e26']}}</td>
    <td>{{item['e27']}}</td>
    <td>{{item['e28']}}</td>
    <td>{{item['e29']}}</td>
    <td>{{item['e30']}}</td>
    <td>{{item['e31']}}</td>
    <td>{{item['e32']}}</td>
    <td>{{item['e33']}}</td>
    <td>{{item['e34']}}</td>
    <td>{{item['e35']}}</td>
    <td>{{item['e36']}}</td>
    <td>{{item['e37']}}</td>
    <td>{{item['e38']}}</td>
    <td>{{item['e39']}}</td>
    <td>{{item['e40']}}</td>
    <td>{{item['e41']}}</td>
    <td>{{item['e42']}}</td>
    <td>{{item['e43']}}</td>
    <td>{{item['e44']}}</td>
    <td>{{item['e45']}}</td>
    <td>{{item['e46']}}</td>
    <td>{{item['e47']}}</td>
    <td>{{item['e48']}}</td>
    <td>{{item['e49']}}</td>
    <td>{{item['e50']}}</td>
  </tr>


</table>


<ng-template #templateFileAttach>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> فایل های ضمیمه شماره نامه '{{Selected_Schedule__FileAttach.code}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_FileAttach.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>فایل</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of ImageAttachFile_List" >
             <td>{{ImageAttachFile_List.indexOf(item)+1}}</td>
              <td>
                <a target="_blank"  href="{{BaseUrl2}}File/Letter/{{item}}" class="btn btn-success"><i class="fa fa-file-pdf-o"></i> PDF </a>
              </td>
          </tbody>
        </table>
     </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modalRef_FileAttach.hide()">بستن</button>
  </div>
</ng-template>
